module.exports = __webpack_public_path__ + "static/media/16.ed9d17a8.png";